<template>
  <div class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section class="select_category">
            <h2>商品を選ぶ</h2>
            <!-- <div>
              <div v-for="(category, index) in categoryList" :key="'cate_' + index">
                <div v-bind:class="{cetegory_item: true, active: category.id === selCategoryData.id}" @click="selectCategory(category)">
                  <div>
                    <img :src="categoryImgBlack(category.img)" v-if="category.id !== selCategoryData.id">
                    <img :src="categoryImgWhite(category.img)" v-else>
                  </div>
                  <div>{{categoryName(category.name)}}</div>
                </div>
              </div>
            </div> -->
            <div class="product_search_cond">
              <div>現在の検索条件:</div>
              <div>{{searchCond}}</div>
            </div>
            <div class="product_search_act">
              <div>該当商品</div>
              <div>{{productCnt}}件</div>
              <div @click="onSearch" class="detail_btn3ex">絞り込み</div>
              <div @click="onReset" class="detail_btn3ex2">条件リセット</div>
            </div>
          </section>
          <!-- <section>
            <div>
              <div class="button01" id="construction">
                <input type="radio" name="construction_radio" id="construction_need" value=1 v-model.number="orderByNewest" />
                <label for="construction_need">新着順</label>
                <span>|</span>
                <input type="radio" name="construction_radio" id="construction_no" checked="" value=0 v-model.number="orderByNewest" />
                <label for="construction_no">人気順</label>
              </div>
            </div>
          </section> -->
          <section>
            <a href="#" id="page_top" v-show="scrollVisible">最上部へ</a>
          </section>
          <section v-if="dcFileDataList.length > 0" v-cloak>
            <div v-for="(prpic, index) in dcFileDataList" :key="index" :value="prpic">
              <div class="prpicDetail">
                <div class="prpicTitle">
                  <p>{{prpic.data.dcPrpicTitle}}</p>
                </div>
                <div class="prpicComment">
                  <p>{{prpic.data.dcPrpicComment}}</p>
                </div>
              </div>
              <div id="product_list">
                <div class="prpicImage">
                  <img :src="getImage(prpic.data.dcPrpicImg)">
                </div>
                <div v-for="(product, index) in prpic.items" class="product" :key="'product-' + index" :value="product" @click="customize(product)">
                  <img :src="getImage(product.dcFdImage)">
                  <div class="product_detail">
                    <div>
                      <p>{{product.makerData.corpName}}</p>
                      <p>{{product.seriesName}}</p>
                    </div>
                    <div>
                      <p class="bold">{{product.dcFdName}}</p>
                      <p class="pickup bold">{{productSize(product.dcMinWidth, product.dcMaxWidth)}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="product_list" ref="product_top" v-if="dcFileDataListSub.length > 0" v-cloak>
            <div v-for="(product, index) in dcFileDataListSub" class="product" :key="'product-' + index" :value="product" @click="customize(product)">
              <img :src="getImage(product.dcFdImage)">
              <div class="product_detail">
                <div>
                  <p>{{product.makerData.corpName}}</p>
                  <p>{{product.seriesName}}</p>
                </div>
                <div>
                  <p class="bold">{{product.dcFdName}}</p>
                  <p class="pickup bold">{{productSize(product.dcMinWidth, product.dcMaxWidth)}}</p>
                </div>
              </div>
            </div>
          </section>
          <!--
          <dd-pager
            :pageNo="pageNo"
            :dataCountPerPage="60"
            :totalDataCount="dcFileDataList.length"
            @paging="paging"
          /> -->
          <div v-if="dcFileDataList.length + dcFileDataListSub.length <= 0">該当する商品がありません。</div>
          <!--
          <section id="product_recom_list">
            <h2>最近チェックした商品からおすすめ</h2>
          </section>
          <section id="product_check_list">
            <h2>最近チェックした商品</h2>
          </section> -->
          <section>
            <h2>お客様に選ばれる3つの理由</h2>
            <dd-reason />
          </section>
          <div v-if="!isHaseko">
            <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import {DC_URL, DC_STORAGE_KEY, DC_PRPIC_ON, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DDReason from '../components/top/DcSelectReason'
// import DcPager from '../components/common/DcPager'
import DcSiteMap from '../components/common/DcSiteMap'

// const PRODUCT_VIEW_SIZE = 60

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-reason': DDReason,
    'dd-loading-modal': LoadingModal,
    // 'dd-pager': DcPager,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcCategory',
      // pageList: [
      //   {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
      //   {id: 'category', key: 'dcCategory', title: '商品を選ぶ', route: 'DcCategory'}
      // ],
      // selectedCategory: 1,
      selCategoryData: {},
      dcFileDataList: [],
      dcFileDataListSub: [],
      // selCategoryNo: 1,
      categoryList: [],
      // pageNo: 1,
      // businessDataList: [],
      productCnt: 0,
      searchCond: '条件なし',
      scrollVisible: false,
      prpicNo: -1,
      user: {}
    }
  },
  computed: {
    pageList: function () {
      let pageList = []
      if (DC_PRPIC_ON === 1) {
        pageList = [
          {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
          {id: 'category', key: 'dcCategory', title: '商品を選ぶ', route: 'DcPrpic'}
        ]
      } else {
        pageList = [
          {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
          {id: 'category', key: 'dcCategory', title: '商品を選ぶ', route: 'DcCategory'}
        ]
      }
      return pageList
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    syncLogin: async function (cid) {
      await this.guestLogin()
      await this.getCategoryList()
      await this.init(cid)
    },
    guestLogin: async function () {
      this.$refs.loadingModalRef.showModal(true)
      await axios.get(DC_URL.LOGIN + '/guest')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.userInfo = response.data.data
            console.log('set guest user:' + Object.entries(this.userInfo))
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, this.userInfo)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    init: function (id) {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {}
      axios.get(DC_URL.TOP + '/init', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // this.dcFileDataList = []
            // response.data.data.dcFileDataList
            //   .forEach(f => {
            //     let dcFileData = this.convertDcFileData(f)
            //     this.dcFileDataList.push(dcFileData)
            //   })
            // this.productCnt = this.dcFileDataList.length
            // this.businessDataList = response.data.data.businessDataList
            this.categoryList = response.data.data
            // if (id === undefined) {
            //   this.selCategoryData = this.categoryList[0]
            // } else {
            //   this.selCategoryData = this.categoryList.find(c => c.id === Number(id))
            // }
            // App.setLocalStorage(DC_STORAGE_KEY.BUSINESS_DATA_LIST, this.businessDataList)
            let serachForm = App.getLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
            if (serachForm && Object.keys(serachForm).length > 0) {
              let paramData = serachForm
              this.searchCond = this.saveSearchCond(paramData)
              let payload = {
                categoryList: serachForm.categoryList.map(c => c.id),
                minWidth: serachForm.paramForm.minWidth,
                maxWidth: serachForm.paramForm.maxWidth,
                minHeight: serachForm.paramForm.minHeight,
                maxHeight: serachForm.paramForm.maxHeight,
                minDepth: serachForm.paramForm.minDepth,
                maxDepth: serachForm.paramForm.maxDepth,
                makerIdList: serachForm.makerIdList
              }
              this.search(payload)
            } else {
              // 条件指定なし
              let paramData = {
                categoryList: this.categoryList.filter(c => c.id === id),
                paramForm: {
                  minWidth: undefined,
                  maxWidth: undefined,
                  minHeight: undefined,
                  maxHeight: undefined,
                  minDepth: undefined,
                  maxDepth: undefined
                },
                makerIdList: undefined
              }
              this.searchCond = this.saveSearchCond(paramData)
              App.setLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH, paramData)
              let categoryList = []
              if (id != null) categoryList.push(id)
              let payload = {
                categoryList: categoryList,
                paramForm: {
                  minWidth: undefined,
                  maxWidth: undefined,
                  minHeight: undefined,
                  maxHeight: undefined,
                  minDepth: undefined,
                  maxDepth: undefined
                },
                makerIdList: undefined
              }
              this.search(payload)
            }
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    convertDcFileData: function (data) {
      let dcFileData = {
        dcFdId: data.dcFdId,
        dcCategoryType: data.dcCategoryType,
        dcFdType: data.dcFdType,
        dcFdName: data.dcFdName,
        dcFileName: data.dcFileName,
        seriesName: data.seriesName,
        dcFdImage: data.dcFdImage,
        dcFdImageB: this.bigImage(data.dcFdImage),
        dcWidth: data.defW,
        dcMinWidth: data.minW,
        dcMaxWidth: data.maxW,
        dcHeight: data.defH,
        dcMinHeight: data.minH,
        dcMaxHeight: data.maxH,
        dcDepth: data.defD,
        dcMinDepth: data.minD,
        dcMaxDepth: data.maxD,
        dcHeight2: data.defH2,
        dcMinHeight2: data.minH2,
        dcMaxHeight2: data.maxH2,
        dcDepth2: data.defD2,
        dcMinDepth2: data.minD2,
        dcMaxDepth2: data.maxD2,
        dcBType: data.btype,
        dcBSize: data.bsize,
        dcCType: data.ctype,
        dcCSize: data.csize,
        dcDType: data.dtype,
        dcDSize: data.dsize,
        dcProductCount: 1,
        dcBTypeDisableFlg: data.btypeDisableFlg,
        dcCTypeDisableFlg: data.ctypeDisableFlg,
        dcDTypeDisableFlg: data.dtypeDisableFlg,
        opShelfDisableFlg: data.opShelfDisableFlg,
        opFillerDisableFlg: data.opFillerDisableFlg,
        opShelfType: data.opShelfType,
        opFillerType: data.opFillerType,
        makerData: data.makerData,
        inputReferenceList: data.inputReferenceList,
        cDcProductManual: data.dcProductManual,
        cDcConstructManual: data.dcConstructManual,
        cDcUserManual: data.dcUserManual,
        categoryImg: data.categoryImg,
        categoryName: data.categoryName,
        prpicData: data.prpicData
      }
      return dcFileData
    },
    getPrPicData: function (data) {
      let dcPrPic = {
        dcPrpicTitle: data.dcPrpicTitle,
        dcPrpicComment: data.dcPrpicComment,
        dcPrpicImg: data.dcPrpicImg
      }
      return dcPrPic
    },
    getCategoryList: async function () {
      await axios.get(DC_URL.TOP + '/category')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
          this.categoryList = response.data.data
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    categoryImgBlack: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    categoryImgWhite: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_white' + exp)
    },
    // selectCategory: function (category) {
    // // ページ数を戻す
    //  this.pageNo = 1
    // // カテゴリ変更処理
    //  this.selCategoryData = category
    //  this.init(this.selCategoryData.id)
    //  this.errors = {}
    //  this.$forceUpdate()
    // },
    productSize: function (min, max) {
      return (min + ' ≦ W ≦ ' + max)
    },
    // paging: function (currentPageNo) {
    //   this.pageNo = currentPageNo
    //   this.scrollToAnchorPoint('product_top')
    // },
    customize: function (product) {
      this.$router.push({
        name: 'DcCustomize',
        query: {id: product.dcFdId, ctype: product.dcCategoryType, dtype: product.dcFdType}
      })
    },
    scrollToAnchorPoint: function (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({behavior: 'auto'})
    },
    categoryName: function (name) {
      if (!name) return ''
      console.log('param:' + name)
      const s = name.replace('（', '\n（')
      console.log(s)
      return s
    },
    onSearch: function () {
      let modalData = {
        categoryList: this.categoryList,
        onOk: (callback) => {
          this.searchCond = this.saveSearchCond(callback)
          App.setLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH, callback)
          document.body.style.overflow = 'scroll'
          let payload = {
            categoryList: callback.categoryList.map(c => c.id),
            minWidth: callback.paramForm.minWidth,
            maxWidth: callback.paramForm.maxWidth,
            minHeight: callback.paramForm.minHeight,
            maxHeight: callback.paramForm.maxHeight,
            minDepth: callback.paramForm.minDepth,
            maxDepth: callback.paramForm.maxDepth,
            makerIdList: callback.makerIdList
          }
          this.search(payload)
        },
        onCancel: (callback) => {
          document.body.style.overflow = 'scroll'
        },
        isHaseko: this.isHaseko,
        callbackParams: {}
      }
      AppEc.showProductSearch(modalData)
      document.body.style.overflow = 'hidden'
    },
    onReset: function () {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      let payload = {
        categoryList: undefined,
        minWidth: undefined,
        maxWidth: undefined,
        minHeight: undefined,
        maxHeight: undefined,
        minDepth: undefined,
        maxDepth: undefined,
        makerIdList: undefined
      }
      this.searchCond = '条件なし'
      this.search(payload)
    },
    search: function (payload) {
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.TOP + '/prpic-search', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // this.productCnt = response.data.data
            this.dcFileDataList = []
            this.dcFileDataListSub = []
            this.prpicNo = -1
            this.productCnt = 0
            let i = -1
            response.data.data
              .forEach(f => {
                this.productCnt++
                let dcFileData = this.convertDcFileData(f)
                if (dcFileData.prpicData !== null) {
                  if (this.prpicNo !== dcFileData.prpicData.dcPrpicNo) {
                    let prpicData = this.getPrPicData(dcFileData.prpicData)
                    this.dcFileDataList.push({
                      data: prpicData,
                      items: []
                    })
                    i++
                    this.prpicNo = dcFileData.prpicData.dcPrpicNo
                  }
                  dcFileData.prpicData.prpicNo = 0
                  this.dcFileDataList[i].items.push(dcFileData)
                } else {
                  this.dcFileDataListSub.push(dcFileData)
                }
              })
            // this.pageNo = 1
            // this.productCnt = this.dcFileDataList.length
          }
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          Api.handleError(error)
          this.modalShown = false
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
        })
    },
    saveSearchCond: function (callback) {
      let searchCondList = []
      if (callback.categoryList) {
        callback.categoryList
          .forEach(c => {
            searchCondList.push(c.name)
          })
      }
      if (callback.paramForm) {
        if (callback.paramForm.minWidth && callback.paramForm.maxWidth) {
          searchCondList.push('幅:' + callback.paramForm.minWidth + 'mm ～ ' + callback.paramForm.maxWidth + 'mm')
        } else if (callback.paramForm.minWidth) {
          searchCondList.push('幅:' + callback.paramForm.minWidth + 'mm')
        } else if (callback.paramForm.maxWidth) {
          searchCondList.push('幅: ～ ' + callback.paramForm.maxWidth + 'mm')
        }
        if (callback.paramForm.minHeight && callback.paramForm.maxHeight) {
          searchCondList.push('高さ:' + callback.paramForm.minHeight + 'mm ～ ' + callback.paramForm.maxHeight + 'mm')
        } else if (callback.paramForm.minHeight) {
          searchCondList.push('高さ:' + callback.paramForm.minHeight + 'mm')
        } else if (callback.paramForm.maxHeight) {
          searchCondList.push('高さ: ～ ' + callback.paramForm.maxHeight + 'mm')
        }
        if (callback.paramForm.minDepth && callback.paramForm.maxDepth) {
          searchCondList.push('奥行き:' + callback.paramForm.minDepth + 'mm ～ ' + callback.paramForm.maxDepth + 'mm')
        } else if (callback.paramForm.minDepth) {
          searchCondList.push('奥行き:' + callback.paramForm.minDepth + 'mm')
        } else if (callback.paramForm.maxDepth) {
          searchCondList.push('奥行き: ～ ' + callback.paramForm.maxDepth + 'mm')
        }
      }
      if (callback.makerIdList) {
        callback.makerIdList
          .forEach(m => {
            if (m === 10000) searchCondList.push('株式会社アクシス')
            if (m === 10001) searchCondList.push('株式会社テクマ')
            if (m === 27) searchCondList.push('ファニチャーメーカー')
            if (m === 1001) searchCondList.push('株式会社みうら')
            if (m === 300) searchCondList.push('ドゥーマンズ株式会社')
          })
      }
      if (searchCondList.length <= 0) return '条件なし'
      return searchCondList.join('、')
    },
    handleScroll: function () {
      this.scrollY = window.scrollY
      if (!this.scrollVisible) {
        this.scrollVisible = window.scrollY > 500
      } else if (window.scrollY < 490) {
        this.scrollVisible = !this.scrollVisible
      }
    }
  },
  watch: {
    $route (to, from) {
      this.init(to.query.cid)
    }
  },
  mounted: function () {
    // カテゴリ
    document.body.style.overflow = 'scroll'
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.syncLogin(this.$route.query.cid)
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    window.addEventListener('scroll', this.handleScroll)
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcPrpic.vue